<script>
	
    export let items

</script>

<div  class="messages">
    {#each items as chatMessage,i (chatMessage.id)}
        <p class="chatmessage {(i%2 == 0) ? 'grey': ''}" data-user={chatMessage.user.name.toString()}> {chatMessage.data.message}</p>
    {/each}
</div>

<style>
	.messages {
		width: 100%;
		font-family: cursive;
	}

	.chatmessage { 
		color: #222;
		text-indent: 16px hanging each-line;
		word-wrap: break-word;
		position: relative;
		padding-bottom: 6px;
	}
	.chatmessage.grey {
		background: #f4f4f4;
	}

	.chatmessage::before {
		content: attr(data-user);
		color:blueviolet;
		text-decoration: underline;
		text-shadow: 1px 0px 0px;
		font-size: 1.1em;
		font-style: italic;
		font-weight: 600;
		padding: 8px;
		display: block;
	}
	
</style>
